export default function guest ({ next, store }) {
  const profile = store.getters['auth/profile']
  if (profile.codeUserType !== 'GUEST') {
    return next({
      name: 'Signin'
    })
  }
  return next()
}



// WEBPACK FOOTER //
// ./src/middleware/guest.js